/* Filter the product gallery to the selected colour.
   Shopify allows only one image per variant, so the colour -> images mapping
   lives in arc-variant-media.json and the filtering happens here. Images not
   in the map are hidden while a colour is selected. */
(function () {
  var MAP = null, root = null, VIMG = {};

  function colourNow() {
    // Dawn names these "Color-<section id>" and Liquid leaves whitespace in the
    // attribute, so match on a trimmed prefix rather than an exact name.
    var els = document.querySelectorAll(
      'select[name], input[type="radio"]:checked, input[type="hidden"][name]'
    );
    for (var i = 0; i < els.length; i++) {
      var n = (els[i].getAttribute('name') || '').trim().toLowerCase();
      if (n.indexOf('color') === 0 || n.indexOf('colour') === 0) {
        var v = (els[i].value || '').trim();
        if (v) return v.toLowerCase();
      }
    }
    // fallback: the fieldset legend prints "Color: <value>"
    var legends = document.querySelectorAll('.product-form__input legend, variant-selects legend');
    for (var j = 0; j < legends.length; j++) {
      var t = (legends[j].textContent || '').replace(/\s+/g, ' ').trim();
      var m = t.match(/^colou?r\s*:\s*(.+)$/i);
      if (m) return m[1].trim().toLowerCase();
    }
    return null;
  }

  function fileOf(img) {
    if (!img) return '';
    var s = img.getAttribute('src') || img.currentSrc || '';
    try { s = decodeURIComponent(s); } catch (e) {}
    return s.split('/').pop().split('?')[0];
  }

  function apply() {
    if (!MAP) return;
    var c = colourNow();
    if (!c) return;

    // The curated map plus whatever image this colour's variant is actually
    // assigned in admin. Without the second half, an image uploaded after the
    // map was written is filtered out of its own colour's gallery.
    var want = (MAP[c] || []).slice();
    if (VIMG[c] && want.indexOf(VIMG[c]) === -1) want.push(VIMG[c]);
    if (!want.length) return;

    function wanted(el) {
      return want.indexOf(fileOf(el.querySelector('img'))) !== -1;
    }

    // Match on the image filename for BOTH the gallery and the thumbnails.
    // Pairing them by media id meant scoping the thumbnail lookup to the
    // gallery element, and the thumbnail list sits outside it -- which is why
    // the main image changed colour but the thumbnails stayed on the first one.
    var firstVisible = null;
    document.querySelectorAll('.product__media-item').forEach(function (item) {
      var show = wanted(item);
      item.classList.toggle('arc-media-hidden', !show);
      if (show && !firstVisible) firstVisible = item;
    });

    document.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
      li.classList.toggle('arc-media-hidden', !wanted(li));
    });

    if (firstVisible) {
      var active = document.querySelector('.product__media-item.is-active');
      if (!active || active.classList.contains('arc-media-hidden')) {
        var id = firstVisible.dataset.mediaId;
        var thumb = id && document.querySelector('[data-target="' + id + '"]');
        if (thumb) thumb.click();
      }
    }
  }

  function start() {
    root = document.querySelector('.product__media-wrapper, media-gallery');
    if (!root) return;
    var holder = document.querySelector('[data-arc-media-map]');
    var url = root.dataset.arcMediaMap || (holder || {}).dataset?.arcMediaMap;
    if (!url) return;

    VIMG = {};
    var raw = (holder && holder.dataset.arcVariantImages) || '';
    raw.split('||').forEach(function (pair) {
      var i = pair.indexOf('::');
      if (i > 0) VIMG[pair.slice(0, i).trim().toLowerCase()] = pair.slice(i + 2).trim();
    });

    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      MAP = j;
      apply();
      document.addEventListener('change', function (e) {
        if (e.target.closest('variant-selects, variant-radios, .product-form__input')) {
          setTimeout(apply, 60);
        }
      });
      // Dawn re-renders the section on variant change
      document.addEventListener('shopify:section:load', function () { setTimeout(start, 60); });
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', start);
  if (document.readyState !== 'loading') start();
})();
